<script>
	export let width = '200px';
	export let height = '200px';

	export let color = '#000000';

	let style = `width: ${width}; height: ${height}`;
</script>

<style>
	div {
		display: inline-block;
		margin: .3rem;
	}
</style>

<div {style}>
	<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100%"
		 height="100%" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
		<g id="Filled_Icons">
			<path fill={color} d="M11.999,0.5C5.649,0.5,0.5,5.648,0.5,12c0,5.082,3.294,9.392,7.865,10.914c0.574,0.103,0.756-0.236,0.756-0.541
				c0-0.274,0.006-1.037,0-1.997C5.923,21.07,5.26,18.861,5.26,18.861c-0.523-1.329-1.275-1.682-1.275-1.682
				C2.94,16.465,4.062,16.48,4.062,16.48c1.153,0.08,1.762,1.184,1.762,1.184c1.026,1.758,2.691,1.25,3.346,0.956
				c0.106-0.742,0.402-1.251,0.731-1.536c-2.554-0.292-5.238-1.277-5.238-5.686c0-1.255,0.448-2.281,1.184-3.086
				c-0.118-0.289-0.514-1.46,0.112-3.043c0,0,0.967-0.309,3.162,1.18c0.918-0.256,1.902-0.383,2.88-0.388
				c0.976,0.005,1.96,0.132,2.88,0.388c2.195-1.488,3.159-1.18,3.159-1.18c0.627,1.583,0.232,2.754,0.114,3.043
				c0.736,0.805,1.183,1.831,1.183,3.086c0,4.42-2.689,5.391-5.251,5.674c0.412,0.357,0.787,1.047,0.787,2.12c0,1.438,0,2.806,0,3.184
				c0,0.308,0.186,0.647,0.77,0.536C20.209,21.389,23.5,17.08,23.5,12C23.5,5.648,18.352,0.5,11.999,0.5z"/>
		</g>
		<g id="Frames-24px">
			<rect fill="none" width="24" height="24"/>
		</g>
	</svg>
</div>